import { KommerSnart } from '../../../components/ui/KommerSnart'

export function OkonomiTab() {
  return (
    <KommerSnart
      description="Økonomiindstillinger: aconto-beregning, fordelingsmetode (areal/forbrug), og fakturaopsætning."
    />
  )
}
